import { Box, Typography } from '@mui/material'
import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

const LoadingComponent: React.FC = () => {
  return (
    <Box sx={{ mb: 2 }}>
      <CircularProgress size={24} sx={{ mr: 2 }}/>
      <Typography variant={'body1'} sx={{ display: 'inline-block', m: 0, verticalAlign: 'top' }} >Loading...</Typography>
    </Box>
  )
}

export default LoadingComponent
